import { jsPDF } from "jspdf";
import { Region, EnvironmentalData } from "@/services/environmentalDataService";
import { pdfColors } from "./colors";
import {
  addDocumentHeader,
  addPageFooters,
  getNextSectionY,
} from "./pdfGenerationUtils";
import { addDeforestationSection } from "./sectionGenerators/deforestationSection";
import { addLandLossSection } from "./sectionGenerators/landLossSection";
import { addDesertificationSection } from "./sectionGenerators/desertificationSection";
import { addEndangeredSpeciesSection } from "./sectionGenerators/endangeredSpeciesSection";
import { addAIInsightsSection } from "./sectionGenerators/aiInsightsSection";
import { AIInsightsData } from "./types";

export const generatePDF = async (
  region: Region,
  data: EnvironmentalData,
  aiData?: AIInsightsData,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      const doc = new jsPDF();

      // Page 1: Rule 5 - Title Block (First page must not start with raw data)
      addDocumentHeader(doc, region);

      // Page 2: Rule 6 - No page should exceed two major sections
      doc.addPage();
      addDeforestationSection(doc, data, 20, pdfColors);

      const landLossY = getNextSectionY(doc, 110);
      addLandLossSection(doc, data, landLossY, pdfColors);

      // Page 3: Desertification and Endangered Species
      doc.addPage();
      addDesertificationSection(doc, data, 20, pdfColors);

      const speciesY = getNextSectionY(doc, 110);
      addEndangeredSpeciesSection(doc, data, speciesY, pdfColors);

      // Page 4: Rule 8 - AI Insights & Carbon Analytics mandatory separation
      if (aiData) {
        doc.addPage();
        addAIInsightsSection(doc, aiData, 20, pdfColors);
      }

      // Add page footers (Rule 9)
      addPageFooters(doc);

      // Save PDF
      doc.save(`${region.name.replace(/\s+/g, "-")}_Environmental_Report.pdf`);
      resolve();
    } catch (error) {
      console.error("Error generating PDF:", error);
      reject(error);
    }
  });
};

export * from "./types";
